import React, { useEffect, useState } from 'react'
import ResponsiveImg, { getResponsiveSrcSetsFromWH } from '../../common/ResponsiveImg'
import styles from './DownloadApp.scss'
import { getGlobalEnv } from '../../../helpers/coreUtil'
import AppMobilePC from '../../../assets/imgs/new-vanshare/appmobile_pc.png'
import AppMobileSP from '../../../assets/imgs/new-vanshare/appmobile_sp.png'
import AppStore from '../../../assets/icons/AppStore.svg'
import GooglePlay from '../../../assets/imgs/new-vanshare/app/google-play.png'
import GooglePlayDimension from '../../../assets/imgs/new-vanshare/app/google-play.png?size'
import { useSm, useTablet } from '../../hocs/hooks'

const DownloadApp = () => {
  const [width, setWidth] = useState(0)
  const isSm = useSm()
  const isTablet = useTablet()

  useEffect(() => {
    if (typeof window !== 'undefined') {
      function handleResize() {
        setWidth(window.innerWidth)
      }
      window.addEventListener("resize", handleResize)
      handleResize()
      return () => window.removeEventListener("resize", handleResize)
    }
    setWidth(width)
  }, [])

  const cdn = getGlobalEnv('CDN_BASE_URL')
  const srcMobilePC = getResponsiveSrcSetsFromWH(AppMobilePC, 1100, undefined, { webp: false, cdn })
  const srcMobileSP = getResponsiveSrcSetsFromWH(AppMobileSP, 335, undefined, { webp: false, cdn })

  return <>
    {!(isSm || isTablet) ? <div className={styles.appMobileContainer}>
        <ResponsiveImg
          url={AppMobilePC}
          caption="Carstayアプリでサクサク予約"
          srcSet={srcMobilePC}
        />
        <a href="https://apps.apple.com/jp/app/id1531721547?l=ja"
          target="_blank"
          rel="noopener noreferrer"
          title="アプリ/apple">
          <AppStore className={styles.appleLinkPc} />
        </a>
        <div className={styles.androidLinkPc}>
          <a href="https://play.google.com/store/apps/details?id=jp.carstay.android&hl=ja"
            target="_blank"
            rel="noopener noreferrer"
            className="my-auto"
            title="アプリ/android">
            <ResponsiveImg
              url={GooglePlay}
              caption="GooglePlay"
              dimension={GooglePlayDimension}
            />
          </a>
        </div>
      </div>
      : <div className={styles.appMobileContainer}>
        <ResponsiveImg
          url={AppMobileSP}
          caption="Carstayアプリでサクサク予約"
          srcSet={srcMobileSP}
        />
        <a href="https://apps.apple.com/jp/app/id1531721547?l=ja"
          target="_blank"
          rel="noopener noreferrer"
          title="アプリ/apple">
          <AppStore className={styles.appleLinkSp} />
        </a>
        <div className={styles.androidLinkSp}>
          <a href="https://play.google.com/store/apps/details?id=jp.carstay.android&hl=ja"
            target="_blank"
            rel="noopener noreferrer"
            className="my-auto"
            title="アプリ/android">
            <ResponsiveImg
              url={GooglePlay}
              caption="GooglePlay"
              dimension={GooglePlayDimension}
            />
          </a>
        </div>
      </div>
  }
  </>
}
DownloadApp.displayName = 'DownloadApp'
export default DownloadApp
